module.exports = __webpack_public_path__ + "static/media/win-reward-last.2a181aae.mp3";